<template>
    <div class="riskList">
        <div class="table-box">
            <div class="title">
                <div class="icon-box">
                    <i class="iconfont icon-xingxing"></i>
                </div>
                <b>星级评定管理</b>
            </div>
            <div class="search-flex">
                <div class="search-box">
                    <el-form ref="form" :model="search" class="flex" label-width="100px">
                        <el-form-item label="关键词">
                            <el-input v-model="search.keyword" placeholder="请输入关键词搜索"></el-input>
                        </el-form-item>
                        <el-form-item label="评定时间">
                            <el-date-picker
                                v-model="search.time"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                type="daterange"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="评定状态">
                            <el-select v-model="search.status" :clearable="true" class="inp" placeholder="请选择">
                                <el-option
                                    v-for="item in evaluateStatusOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="search-btn" @click="searchList">
                        <i class="iconfont icon-sousuo"></i>搜索
                    </div>
                    <div class="search-btn reset" @click="reset">
                        <i class="iconfont icon-huanxiang"></i>重置
                    </div>
                    <div class="shensu margin-left-sm" @click="addItem(false)">
                        <i class="iconfont icon-send"></i>发布星级评定
                    </div>
                </div>
            </div>
            <div class="list flex flex-direction">
                <div class="flex flex-wrap">
                    <div class="item-evaluate" :class="{ed:item.status === 3}" v-for="item in tableData" :key="item.id">
                        <div class="status" >{{item.status | status}}</div>
                        <div class="name">{{item.title}}</div>
                        <div class="content margin-top-sm">
                            <div class="flex">
                                <div class="icon iconfont icon-shijian3"></div>
                                <div class="info">{{item.start_time}}-{{item.end_time}}</div>
                            </div>
                            <div class="flex margin-tb-sm">
                                <div class="icon iconfont icon-shengyin"></div>
                                <div class="info ovHide4">{{item.message}}</div>
                            </div>
                            <div class="flex">
                                <div class="icon iconfont icon-zhongdiedu"></div>
                                <div class="info">{{item.org_num}}</div>
                            </div>
                            <div class="flex justify-end margin-top-sm">
                                <div class="operate" @click="addItem(item)" v-if="item.status !== 3"><i class="icon iconfont icon-bianji1"></i>编辑</div>
                                <div class="operate" v-if="item.status === 2"> <i class="icon iconfont icon-shuyi_zanting"></i>暂停</div>
                                <div class="operate" v-if="item.status === 1"> <i class="icon iconfont icon-gengduo1"></i>开始</div>
                                <div class="operate blue"  @click="toTotal(item)"> <i class="icon iconfont icon--caidan"></i>详情</div>
                                <div class="operate red" @click="delItem(item)"> <i class="icon iconfont icon-shanchu"></i>删除</div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-empty v-if="tableData.length == 0" description="暂无数据" class="self-center"></el-empty>
                <div class="page-box">
                    <el-pagination
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        background
                        class="page-all margin-top self-end"
                        layout="prev, pager, next"
                        @current-change="list">
                    </el-pagination>
                </div>
            </div>
        </div>
        <add-evaluate-dialog :dialog-visible="addEvaluateDialog" :id="cur_id" :readonly="cur_type" @handleClose="handleClose"></add-evaluate-dialog>
    </div>
</template>
<script>
import {delEvaluate, getEvaluateList} from "@/api/admin";
import {evaluateStatusOptions} from "@/utils/const";
import AddEvaluateDialog from "@/views/admin/pages/evaluate/common/addEvaluateDialog";
import {findByType,confirm} from "@/utils/utils";

export default {
    name: "evaluate",
    data() {
        return {
            evaluateStatusOptions:evaluateStatusOptions,
            search: {
                status: '',
                keyword: '',
                time: [],
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],
            loading: false,

            cur_id: '',
            cur_type: false,
            addEvaluateDialog: false,
        }
    },
    components: {AddEvaluateDialog},
    computed: {

    },
    created() {
        this.$emit("setActive", {
            headActive: 3
        })
        this.list()
    },
    methods: {
        async list() {
            this.loading = true;
            let _data = await getEvaluateList(
                this.search.keyword,
                this.search.time.join(','),
                this.search.status,
                this.search.page,
                this.search.limit
            );
            this.loading = false;
            if (_data.status == 200) {
                this.tableData = _data.data.data
                this.search.total = _data.data.total
            } else {
                this.$message.error(_data.msg)
            }
        },
        addItem(item, type = false){
            this.cur_id = item.id
            this.cur_type = type
            this.addEvaluateDialog = true
        },
        toTotal(item) {
            this.$router.push(`/admin/evaluateTotal?id=${item.id}`)
        },
        delItem(item) {
           confirm('删除','您确定要删除该星级评定吗？',()=>{
               this.delEvaluate(item.id)
           },'确定',true)
        },
        async delEvaluate(id) {
            let _data = await delEvaluate(id);
            if (_data.status == 200) {
                this.$message.success('删除成功')
                this.list()
            } else {
                this.$message.error(_data.msg)
            }
        },
        searchList() {
            this.search.page = 1
            this.list()
        },
        reset() {
            this.search = {
                org_name: '',
                license: '',
                is_lock: '',
                peixun_lei: '',
                page: 1,
            }
            this.list()
        },
        handleClose(data){
            if (data)this.list()
            this.addEvaluateDialog = false
        }
    },
    watch: {},
    filters: {
        status(val) {
            return findByType(evaluateStatusOptions, val)
        }
    }
}
</script>

<style lang="scss" scoped>
.riskList {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 0 20px;
        border-radius: 10px;
        min-height: 500px;


        .title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-top: 25px;
            padding-bottom: 25px;
            border-bottom: 2px solid #e3e7f0;
            b {
                font-size: 22px;
                color: #16181d;
                font-weight: bold;
                margin-left: 10px;
            }

            .icon-box {
                width: 30px;
                height: 30px;
                background-image: linear-gradient(-30deg,
                    #3579fb 0%,
                    #44a3ff 100%);
                box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
                border-radius: 10px;
                text-align: center;
                line-height: 30px;

                i {
                    font-size: 20px;
                    color: #ffffff;
                }
            }
        }

        .list {
            width: 100%;
            min-height: calc(100vh - (173px + 159px + 350px));

            .item-evaluate{
                width: 439px;
                background-image: linear-gradient(0deg,
                    #eef6ff 0%,
                    #5eadff 100%);
                border-radius: 10px;
                border: solid 1px #ffffff;
                padding: 25px 20px;
                position: relative;
                overflow: hidden;
                margin-bottom: 38px;
                &:not(:nth-child(4n + 1)){
                    margin-left: calc((100% - 4 * 439px)/3);
                }

                &.ed{
                    background-image: linear-gradient(0deg,
                        #e7eaed 0%,
                        #bdc4ca 100%);
                    box-shadow: 1px 3px 10px 0px
                    rgba(2, 28, 58, 0.22);
                    .status{
                        background: #707070;
                    }
                }

                .status{
                    position: absolute;
                    width: 114px;
                    height: 58px;
                    line-height: 60px;
                    padding-top: 10px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f59a32;
                    text-align: center;
                    top: -7px;
                    right: -37px;
                    transform: rotate(45deg);
                }

                .name{
                    font-size: 20px;
                    line-height: 16px;
                    color: #ffffff;
                }

                .content{
                    background-color: #ffffff;
                    border-radius: 10px;
                    padding: 25px;
                }
                .icon{
                    font-size: 20px;
                    line-height: 26px;
                    color: #bec2cd;
                    margin-right: 20px;
                }
                .info{
                    font-size: 16px;
                    line-height: 26px;
                    color: #7d8189;
                }

                .operate{
                    width: 80px;
                    height: 36px;
                    background-color: #ffffff;
                    border-radius: 4px;
                    border: solid 1px #2791ff;
                    font-size: 16px;
                    line-height: 36px;
                    text-align: center;
                    color: #2791ff;
                    cursor: pointer;
                    &:not(:nth-child(4n + 1)){
                        margin-left: calc((100% - 4 * 80px)/3);
                    }
                    .icon{
                        color: #2791ff;
                        font-size: 16px;
                        margin-right: 0;
                    }
                    &.blue{
                        background-color: #2791ff;
                        color: #ffffff;
                        .icon{
                            color: #ffffff;
                        }
                    }
                    &.red{
                        border: solid 1px #f34336;
                        color: #f34336;
                        .icon{
                            color: #f34336;
                        }
                    }
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                width: 163px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-left: 15px;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }

}
</style>


